export const en = {
    'inconsistent-ad-group-type-to-campaign-type': "The type of ad group created doesn't match the campaign type",
    'max-adgroups-in-campaign': 'Maximum number of ad groups per campaign reached',
    'name-prohibited-symbols': 'Ad group name contains forbidden characters'
};
